import React from "react"
import { motion } from "framer-motion"
import styled, { css } from "styled-components"

import Icon from "../global/icon"

const size = {
  tablet: 950,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const CameraWrapper = styled(motion.div)`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 65%;
  background: transparent;
  padding: 400 48 40px;
  display: flex;
  align-items: flex-end;
  .closed-inner-wrapper {
    margin: 0px auto;
    width: 100%;
    max-width: 1248px;
    padding: 0px 48px 40px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;

    ${below.tablet`
    padding: 0 48px 40px;
  `}

    ${below.mobile`
    padding: 0 24px 40px;
  `}
  }
`
const Caption = styled(CameraWrapper)`
  background: rgb(0, 0, 0);
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(135, 135, 135, 0) 100%
  ) !important;
  .open-inner-wrapper {
    margin: 0px auto;
    width: 100%;
    max-width: 1248px;
    padding: 0px 48px 40px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between !important;
    ${below.mobile`
    padding: 0 24px 40px;
    flex-direction: column;
  `}
  }
  svg {
    stroke: white;
  }
  p {
    display: block;
    color: white;
    max-width: 424px;
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    margin-bottom: 0;
    ${below.mobile`
    font-size: 16px;
    line-height: 20px;
     max-width: 100%;`}
  }
`
const IconWrapper = styled.button`
  cursor: pointer;
  display: flex;
  border: none;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  background-color: transparent;
  border-radius: 2.8px;
  &.camera {
    background-color: hsla(214, 32%, 91%, 0.45);
    svg {
      height: 24px;
      width: 30px;
      ${below.tablet`height: 14px;width:17px;`}
    }
    ${below.tablet`
      width: 32px;
      height: 32px;
    `}
  }
  &.close {
    svg {
      height: 32px;
      width: 32px;
      ${below.mobile`height: 24px;width:24px;`}
      path {
        stroke: #fff;
      }
    }
    ${below.mobile`
      width: 32px;
      height: 32px;
  `}
  }
`

const HeroCaption = props => {
  return (
    <>
      {!props.isToggled ? (
        <CameraWrapper initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <div className="closed-inner-wrapper">
            <IconWrapper
              className="camera"
              onClick={() => props.setToggle(!props.isToggled)}
            >
              <Icon icon="camera" />
            </IconWrapper>
          </div>
        </CameraWrapper>
      ) : (
        <Caption initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <div className="open-inner-wrapper">
            <p>{props.caption}</p>
            <IconWrapper
              className="close"
              onClick={() => props.setToggle(!props.isToggled)}
            >
              <Icon icon="closeDrawer" />
            </IconWrapper>
          </div>
        </Caption>
      )}
    </>
  )
}

export default HeroCaption
